/**
 * Ayuda — Administración → Productos
 */

import { ADM_PRO_ARTICLES_ITEM } from './adm-pro-articles.js'
import { ADM_PRO_WAREHOUSES_ITEM } from './adm-pro-warehouses.js'
import { ADM_PRO_STOCK_ITEM } from './adm-pro-stock.js'
import { ADM_PRO_ARTICLE_GROUPS_ITEM } from './adm-pro-article-groups.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ADM_PRO_HELP = {
  screenId: 'adm-pro',
  label: 'Productos',
  navPath: 'Administración → Productos',
  keywords: [
    'producto', 'productos', 'artículo', 'articulo', 'stock', 'depósito', 'deposito',
    'almacén', 'inventario', 'grupo de artículos', 'estockeable', 'movimiento',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Productos administrás artículos, depósitos, existencias y grupos. El menú de la izquierda tiene cuatro opciones. Tocá cada tema para el paso a paso.',
  sidebarItems: [
    ADM_PRO_ARTICLES_ITEM,
    ADM_PRO_WAREHOUSES_ITEM,
    ADM_PRO_STOCK_ITEM,
    ADM_PRO_ARTICLE_GROUPS_ITEM,
  ],
}
